import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

type TabButtonType = 'basic' | 'color';

interface TabButtonProps {
  title: string;
  active?: boolean;
  onClick?: () => void;
  type?: TabButtonType;
  color?: string;
  value?: string | number;
}

const TabButton: React.FC<TabButtonProps> = ({
  title,
  active = false,
  onClick,
  type = 'basic',
  color,
  value
}) => {
  const darkColors = ['blue', 'purple'];
  const isColored = type === 'color';
  const isDarkBg = color && darkColors.includes(color);

  return (
    <button
      className={classNames(styles.tabButton, {
        [styles.active]: active,
        [styles.darkBg]: isDarkBg,
        [styles.colored]: isColored
      })}
      onClick={onClick}
      value={value?.toString()}
      aria-selected={active}
    >
      {isColored && (
        <span
          className={styles.colorBar}
          style={{ backgroundColor: color ? `var(--${color})` : undefined }}
        />
      )}
      <span className={styles.title}>{title}</span>
    </button>
  );
};

export default TabButton;
